<div class="td-cnt-ext">
    <div class="td-cnt">
        <div class="td-cnt-title">
            <span class="te-title">{{ 'enquiryBook.openITDCR' | translate}}</span>
        </div>
        <div class="td-cnt-body">
            <div style="width: 100%;display: flex;flex-direction: column;">
                <!-- STEP 1 -->
                <div [hidden]="currentStep() !== 1">
                    <div style="display: flex;align-items: flex-end;">
                        <teiasoft-select [labelText]="'grid.Mill' | translate" [isMobile]="isMobile" [isRequired]="true"
                            [disabled]="false" [optionsList]="millOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                            [isValid]="true" [defaultValue]="selectedMill" (onSelected)="onSelectedMill($event)"
                            [readOnly]="false"></teiasoft-select>
                        <div class="categories">
                            <mat-checkbox [(ngModel)]="FValue">
                                {{'grid.FeasibilityFull' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="PValue">
                                {{'grid.CostsFull' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="DValue">
                                {{'grid.DeliveryFull' | translate}}
                            </mat-checkbox>
                        </div>
                    </div>
                    <teiasoft-grid [title]="'edit-enquiry-item'" [gridDescription]="'enquiryBook.items' | translate"
                        [autoCompleteId]="'order-ec-items'" [columnsToShow]="columnsToShowItem"
                        [dataSet]="filteredItems()" [customIcoCols]="customIcoCols" [calculatedCols]="calculatedCols"
                        [showFooter]="false" [selectable]="true" [multiSelection]="true" [disableAllSelection]='false'
                        [autoWidth]="true" [showEditIcon]="false" [dateFormat]="globals.dateFormat!"
                        [dateTimeFormat]="globals.dateTimeFormat!" [sortable]="false" [enquiryNo]="enquiryNo!"
                        [gridName]="'items'" (rowsSelected)="onRowSelection($event)" [selectedRows]="selectedItems"
                        [customRenderers]="customRenderers"
                        [customHeaderRenderers]="customHeaderRenderers"></teiasoft-grid>
                    <div style="max-width: 200px;">
                        <teiasoft-datetime [value]="dueDate" [labelText]="'grid.ITDCRDueDate' | translate"
                            [type]="'date'" [isRequired]="false" [disabled]="false" [isMobile]="isMobile"
                            [isValid]="true" [dateFormat]="globals!.dateFormat!" (onChange)="onChangeDueDate($event)">
                        </teiasoft-datetime>
                    </div>
                </div>
                <!-- STEP 2 -->
                <div [hidden]="currentStep() !== 2">
                    <h3 style="margin-bottom:12px;">{{ 'enquiryBook.attachment' | translate }}</h3>

                    <!-- Existing (read-only) -->
                    <div>

                        <!-- Accordion view -->
                        <mat-accordion *ngIf="attachmentGroups?.length; else noData" multi>
                            <mat-expansion-panel *ngFor="let group of attachmentGroups">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{ group.label }}
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        <mat-chip-set>
                                            <mat-chip>{{ group.items.length }}</mat-chip>
                                        </mat-chip-set>
                                    </mat-panel-description>
                                </mat-expansion-panel-header>

                                <!-- List of files -->
                                <mat-list role="list">
                                    <mat-list-item role="listitem" *ngFor="let att of group.items; trackBy: trackByAtt">
                                        <div class="file-download">
                                            <div matListItemTitle class="file-title" [title]="att.fileName"
                                                [ngClass]="{'is-excluded': group.key === 'itdcr' && isPreviousItdcrAttachmentExcluded(att)}">
                                                <span class="ml-8">{{ att.fileName }}</span>
                                            </div>
                                            <div matListItemLine class="file-meta">
                                                <span class="date">
                                                    {{ att.fileDate ? (att.fileDate | date:'short') : '' }}
                                                </span>
                                            </div>
                                            <button mat-stroked-button class="ml-auto" (click)="downloadExisting(att)">
                                                <span class="ml-4">{{ 'commons.donwload' | translate }}</span>
                                            </button>
                                            <button *ngIf="group.key === 'itdcr' && isPreviousItdcrAttachment(att)" mat-stroked-button
                                                class="ml-4" (click)="togglePreviousItdcrAttachment(att)">
                                                <ng-container *ngIf="isPreviousItdcrAttachmentExcluded(att); else excludePreviousAttachmentIcon">
                                                    <i class="fal fa-trash-undo ml-4"></i>
                                                </ng-container>
                                                <ng-template #excludePreviousAttachmentIcon>
                                                    <i class="fal fa-trash-alt ml-4"></i>
                                                </ng-template>
                                            </button>
                                        </div>
                                    </mat-list-item>
                                </mat-list>
                                <mat-divider></mat-divider>
                            </mat-expansion-panel>
                        </mat-accordion>

                        <ng-template #noData>
                            <div style="opacity: .7; padding: 8px 0;">
                                {{ 'commons.noAttachments' | translate }}
                            </div>
                        </ng-template>
                    </div>

                    <!-- New uploads -->
                    <input type="file" multiple class="file-upload" (change)="addNewFiles($event)"
                        style="display: none;" id="itdcrFileUploadAttach">
                    <teiasoft-button (onClick)="onAddAttachmentClick()" class="mr-5 mt-3" [type]="'tb-primary'"
                        [text]="'itdcr.attachFile' | translate" [theme]="theme" [isMobile]="isMobile"
                        style="margin-bottom: 1.2rem;display: block;"></teiasoft-button>

                    <div>
                        <div style="display:flex; flex-direction:column; gap:8px;">
                            <div *ngFor="let na of newAttachments; let i = index"
                                style="display:flex; align-items:center; gap:12px;">
                                <i class="fal fa-trash-alt tg-custom-icon" (click)="removeNewAttachment(i)"
                                    style="cursor: pointer;"></i>
                                <span>{{ na.fileName }}</span>
                                <span style="opacity:.7;">{{ na.fileCreationDate | date:'short' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STEP 3 -->
                <div [hidden]="currentStep() !== 3">
                    <teiasoft-select [labelText]="'enquiryBook.SendTo' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [optionsList]="sendToOptionList!" [spaceLabel]="true"
                        [noMinWidth]="true" [isValid]="true" [defaultValue]="selectedSendTo"
                        (onSelected)="onSelectedSendTo($event)" [readOnly]="false"
                        style="width: fit-content;display: block;"></teiasoft-select>
                    <textarea style="width:95%" rows="5" [(ngModel)]="notes"
                        [placeholder]="'commons.notes' | translate"></textarea>
                </div>
            </div>
        </div>
        <div class="td-cnt-btn">
            <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                class="mr-5"></teiasoft-button>

            <ng-container *ngIf="currentStep() > 1">
                <teiasoft-button (click)="prevStep()" [type]="'tb-secondary'" [text]="'commons.previous' | translate"
                    class="mr-5">
                </teiasoft-button>
            </ng-container>

            <!-- Step 1-2 buttons -->
            <ng-container *ngIf="currentStep() < 3">
                <teiasoft-button (click)="nextStep()" [type]="'tb-primary'" [text]="'commons.next' | translate"
                    class="mr-5" [disabled]="!isCurrentStepComplete()">
                </teiasoft-button>
            </ng-container>

            <!-- Step 2 buttons -->
            <ng-container *ngIf="currentStep() === 3">
                <teiasoft-button (click)="preview()" [type]="'tb-active'" [text]="'commons.excelPreview' | translate"
                    class="mr-5" [disabled]="!isCurrentStepComplete()">
                </teiasoft-button>
                <teiasoft-button (click)="save()" [type]="'tb-primary'" [text]="'commons.confirm' | translate"
                    class="mr-5" [disabled]="!isCurrentStepComplete()">
                </teiasoft-button>
            </ng-container>
        </div>
    </div>
</div>
